import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { CapsuleButtonWrapper } from "../ContributionType/styles";
import { SectionHeading, Disclaimer, ContribType, EditButtonWrap, EditWrap, BusinessDate } from './styles';
import history from "../../../../../../history/history";
import ContributionType from "./Components/ContributionType/ContributionType";
import {createContribution, updateContributionError} from '../../actions';
import { getAccountData, getPrimaryAccount, isGeminiUser } from "../../../../../../utils/sessionUtil";
import replaceNonDigit from "../../../../../../utils/replaceNonDigit";
import { filterStateDesc, filterCountryDesc} from "../../../../../MyAccounts/Components/Data/DropDownData";
import Allocation from "./Components/ReviewAllocation/Allocation";
import { Row, Col} from 'antd';
import InvestmentAllocationCard from "./Components/InvestmentAllocationCard/InvestmentAllocationCard";
import { DisplayFlexSpaceMobile, ComponentDivide } from "../InvestmentOptions/styles";
import EditLinkToPill from "../../../../../../CommonComponents/EditLinkToPill/EditLinkToPill";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { DisplayFlex, Spinner } from "../../../../../../CommonComponents/commonStyles";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import Popup from "../ContributionType/Components/Popup/Popup";
import { replacer } from "../../../../../../utils/nameFormatter";
import moment from "moment";
import { reviewContributionAndSubmitState } from "../../selectors";

let popUpState = false;
let isSubmitClicked = false;

export class ReviewContributionAndSubmit extends React.Component {

  constructor(props) {
    super(props);
    this.state = { show: false };
    isSubmitClicked = false;
    popUpState = false;
  }

  componentWillMount() {
    isSubmitClicked = false;
  }

    handleNext() {
      try {
        if(!this.state.isSubmitClicked)
        {
          this.setState({
            isSubmitClicked:true
          })
        const poolData = this.createAllocationPostSchema();
        const contributionInfo = this.createContributionPostSchema();
        let finalData = {
          partyId: getAccountData().partyId,
          accountId:getPrimaryAccount().userId,
          nonVBSSecurities: [{"security": contributionInfo.nonVBSSecurities}],
          multiFundPools: poolData.multiFundPools,
          singleFundPools: poolData.singleFundPools,
          checks: contributionInfo.checks,
          wires: contributionInfo.wires,
          nonVBSMutualFundsBlocks:[{"security": contributionInfo.nonVBSMutualFundsBlocks}],
          funds: contributionInfo.funds,
          vbsSecurity: contributionInfo.vbsSecurity,
          stockCertificates: contributionInfo.stockCertificates
        }
        const data = {
          method: "POST",
          page: "MakeAContribution",
          url: `/DP/FinancialAccount/MAC`,
          data: finalData,
          isBhoomiUrl:true,
        };
        let cb =new Promise((resolve)=>(data.submitDone = resolve));
        cb.then((isError)=>{
          if(!isError)
          {
          isSubmitClicked = true;
          }
          this.setState({
            isSubmitClicked:false
          })
        })
        this.props.createContribution(data);
        this.setState({show: true});
      }
      } catch (error) {
        recordError(error);
      }
    }


    handleBackClick = () => {
      try {
        this.analyticsTracking('Back');
        history.push("/contributions/make-a-contribution/investment-allocation");
      } catch (error) {
        recordError(error);
      }
    }

  donorTypeId = (donorType) => {
    let value = null;
    if(donorType === "Individual"){
      value = "I"
    }else if(donorType === "Joint"){
      value = "J"
    }else if(donorType === "Trust"){
      value = "30"
    }else if(donorType === "Corporation"){
      value = "10"
    }else if(donorType === "Private Foundation"){
      value = "20"
    }else if(donorType === "Other donor-advised fund"){
      value = "70"
    }
    return value;
  }

  getAddressType = (donorType,addressType)=>{

    if(donorType === "I" || donorType === "J")
    {
      return addressType
    }
    else if(donorType === "30")
    {
      return "Other"
    }
    else
    {
      return "Business"
    }
    
  }

  createContributionPostSchema = () => {
    let data = this.props.contributionTypes;
    let assetAtMfs = data.assetHeldatVG.mfSelected ? data.assetHeldatVG.mutualFund : null;
    let assetAtSgs = data.assetHeldatVG.sgSelected ? data.assetHeldatVG.securityGift : null;
    let assetOutMfs = data.assetOutsideVG.mfSelected ? data.assetOutsideVG.mutualFund : null;
    let assetOutSgs = data.assetOutsideVG.sgSelected ? data.assetOutsideVG.securityGift : null;
    let check = data.checkOrEBT.checkSelected ? data.checkOrEBT.checkEBTList : null;
    let wire = data.wire.wireSelected ? data.wire.wireList : null;
    let stock = data.stockCertificate.stockSelected ? data.stockCertificate.stockCertificateList : null;
    let funds = [];
    let vbsSecurity = [];
    let nonVBSMutualFundsBlocks = [];
    let nonVBSSecurities = [];
    let checks = [];
    let wires = [];
    let stockCertificates = [];
    if(assetAtMfs){
      assetAtMfs.map((fund) => {
        let fundInfo = fund.fundInformation;
        fundInfo.map((data) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
          let relationShipId = null;
            let donorType = this.donorTypeId(fund.type);
            if(donorType !== "I"){
              relationShipId = fund.Donors[1]?.["relationToDonor"]
            }

          funds.push({
              "receiveDate": null,
              "expectedReceiveDate": null,
              "createdDate": moment(new Date(), "MM/DD/YYYY").format("YYYY-MM-DD"),
              "approveDate": null,
              "amount": null,
              "shares": data.allShare ? '' : (data.numberofShares.toString()).replace(/,/g, ''),
              "approximateValue": null,
              "seqVanguardSSOId": null,
              "vanguardTxnUUID": null,
              "name": data.fundName,
              "securityStatus": null,
              "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
              "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
              "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
              "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
                "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
                "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
                "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
                "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
                "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType": this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
              } : null,
              "donorAddress": donorType === "J" ? {
                "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
                "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
                "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
                "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
                "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
              } : null,
              "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20" || donorType === "30" || donorType === "70") ? relationShipId : null,
              "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
              "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null,
              "donorType": donorType,
              "fundCompany": null,
              "fundShortName": null,
              "ticker": data.tickerSymbol,
              "accountNumber": fund.VGAccountNumber,
              "limit": null,
              "fundNumber": data.fundNumber,
              "cusip": data.cusip,
              "originatingFirmName": null,
              "allShares": data.allShare,
              "authDocumentReceived": false,
              "authDocumentReceivedDate": null,
              "authDocumentSentDate": null,
              "donorOrgTIN": donorType !== "I" ? fund.Donors[1]?.taxIdNumber : null
          });
        })
      });
    }

    if(assetAtSgs){
      assetAtSgs.map((fund) => {
        let fundInfo = fund.fundInformation;
        fundInfo.map((data) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
            let donorType = this.donorTypeId(fund.type);
            let relationShipId = null;
            if(donorType !== "I"){
              relationShipId = fund.Donors[1]?.["relationToDonor"]
            }

            vbsSecurity.push({
            "donorType": donorType,
            "fundNumber": null,
            "name": data.securityName,
            "numShares": null,
            "shares": null,
            "numberOfShares": data.allShare ? '' : (data.numberofShares.toString()).replace(/,/g, ''),
            "allShares": data.allShare,
            "origAccountName": null,
            "origAccountNumber": fund.VGAccountNumber,
            "tickerSymbol": null,
            "ticker": data.tickerSymbol,
            "expectedReceiveDate": null,
            "createdDate": moment(new Date(), "MM/DD/YYYY").format("YYYY-MM-DD"),
            "securityStatus": {
              "codeValue": null
            },
            "approximateValue": null,
            "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
            "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
            "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
            "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
                "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
                "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
                "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
                "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
                "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
              } : null,
              "donorAddress": donorType === "J" ? {
                "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
                "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
                "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
                "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
                "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType": this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
              } : null,
              "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20" || donorType === "30" || donorType === "70") ? relationShipId : null,
              "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
              "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null,
          });
        })
      });
    }

    if(assetOutMfs){
      assetOutMfs.map((fund) => {
        let fundInfo = fund.fundInformation;
        fundInfo.map((data) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
            let donorType = this.donorTypeId(fund.type);
            let relationShipId = null;
            if(donorType !== "I"){
              relationShipId =fund.Donors[1]?.["relationToDonor"];
            }

            nonVBSMutualFundsBlocks.push({
            "donorType": donorType,
            "fundNumber": data.fundNumber,
            "name": data.fundName,
            "numShares": data.allShare ? '' : (data.numberofShares.toString()).replace(/,/g, ''),
            "cusip": data.cusip,
            "origAccountName": fund.holdingFirm,
            "origAccountNumber": fund.accountNumber,
            "tickerSymbol": data.tickerSymbol,
            "hiddenTicker":data.hiddenTicker,
            "securityStatus": {
              "codeValue": null
            },
            "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
            "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
            "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
            "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorAddress": donorType === "J" ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType": this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20" || donorType === "30" || donorType === "70") ? relationShipId : null,
            "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
            "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null
          });
        })
      });
    }

    if(assetOutSgs){
      assetOutSgs.map((fund) => {
        let fundInfo = fund.fundInformation;
        fundInfo.map((data) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
            let donorType = this.donorTypeId(fund.type);
            let relationShipId = null;
            if(donorType !== "I"){
              relationShipId = fund.Donors[1]?.["relationToDonor"]
            }

            nonVBSSecurities.push({
            "donorType": donorType,
            "fundNumber": null,
            "name": data.securityName,
            "numShares": data.allShare ? '' : (data.numberofShares.toString()).replace(/,/g, ''),
            "origAccountName": fund.holdingFirm,
            "origAccountNumber": fund.accountNumber,
            "tickerSymbol": data.tickerSymbol,
            "hiddenTicker":data.hiddenTicker,
            "securityStatus": {
              "codeValue": null
            },
            "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
            "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
            "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
            "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType": this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorAddress": donorType === "J" ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20"|| donorType === "30" || donorType === "70") ? relationShipId : null,
            "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
            "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null
          });
        })
      });
    }

    if(check){
      check.map((fund) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
            let donorType = this.donorTypeId(fund.type);
            let relationShipId = null;
            if(donorType !== "I"){
              relationShipId = fund.Donors[1]?.["relationToDonor"];
            }

          checks.push(
          {
            "amount": replaceNonDigit(fund.amount).replace(/,/g, ''),
            "donorType": donorType,
            "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
            "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
            "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
            "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorAddress": donorType === "J" ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20"|| donorType === "30" || donorType === "70") ? relationShipId : null,
            "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
            "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null
          });
      });
    }

    if(wire){
      wire.map((fund) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
            let donorType = this.donorTypeId(fund.type);
            let relationShipId = null;
            if(donorType !== "I"){
              relationShipId = fund.Donors[1]?.["relationToDonor"];
            }

          wires.push({
            "amount": replaceNonDigit(fund.amount).replace(/,/g, ''),
            "donorType": donorType,
            "ticker": null,
            "fundNumber": null,
            "targetAccount": {
              "accountNumber": null
            },
            "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
            "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
            "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
            "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorAddress": donorType === "J" ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType": this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20" || donorType === "30" || donorType === "70") ? relationShipId : null,
            "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
            "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null
          });
      });
    }

    if(stock){
      stock.map((fund) => {
        let fundInfo = fund.fundInformation;
        fundInfo.map((data) => {
          let addressType = fund.Donors[1] ? fund.Donors[1].addressType : null;
            let donorType = this.donorTypeId(fund.type);
            let relationShipId = null;
            if(donorType !== "I"){
              relationShipId = fund.Donors[1]?.["relationToDonor"]
            }
            stockCertificates.push({
            "securityName": data.securityName,
            "ticker": data.tickerSymbol,
            "approximateValue": null,
            "amount": null,
            "numberOfShares": (data.numberofShares.toString()).replace(/,/g, ''),
            "donorType": donorType,
            "fundNumber": null,
            "targetAccount": {
              "accountNumber": null
            },
            "securityStatus": {
              "codeValue": null
            },
            "assetType": {
              "codeValue": null
            },
            "donorFirstName": donorType === "J" ? fund.Donors[1]?.firstName : null,
            "donorLastName": donorType === "J" ? fund.Donors[1]?.lastName : null,
            "donorOrgName": !(donorType === "J" || donorType === "I") ? fund.Donors[1]?.name : null ,
            "donorOrgAddress": !(donorType === "J" || donorType === "I") ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorAddress": donorType === "J" ? {
              "line1": fund.Donors[1] ? fund.Donors[1].Address.line1 : null,
              "line2": fund.Donors[1] ? fund.Donors[1].Address.line2 : null,
              "line3": fund.Donors[1] ? fund.Donors[1].Address.line3 : null,
              "city": fund.Donors[1] ? fund.Donors[1].Address.city : null,
              "state": fund.Donors[1] ? (fund.Donors[1].Address.country === "United States" ? filterStateDesc(fund.Donors[1].Address.state, this.props.dropdownVal.states)[0]["desc"] : fund.Donors[1].Address.state) : null,
                "foreignState": fund.Donors[1]?.Address.country !== "United States" ? fund.Donors[1]?.Address.state : null,
                "AddressType":this.getAddressType(donorType,addressType),
                "zip": fund.Donors[1] ? fund.Donors[1].Address.zipCode : null,
                "country": fund.Donors[1] ? filterCountryDesc(fund.Donors[1].Address.country,this.props.dropdownVal.countries)[0]["desc"] : null
            } : null,
            "donorRelationshipTypeId": (donorType === "J" || donorType === "10" || donorType === "20" || donorType === "30" || donorType === "70") ? relationShipId : null,
            "trustDonorRelationshipTypeId":  donorType === "30" ? relationShipId : null ,
            "orgDonorRelationshipTypeId": (donorType === "10" || donorType === "20" || donorType === "70") ? relationShipId : null
          });
        })
      });
    }
    return {funds, vbsSecurity, nonVBSMutualFundsBlocks, nonVBSSecurities, checks, wires, stockCertificates}
  }

  createAllocationPostSchema = () => {
    let defaultAllocationData = this.props.defaultAllocationData;
    let combinedData = []; 
    let multiFundPools = [];
    let singleFundPools = [];
    let updatedPoolData = this.props.defaultAllocationData;
    let arr = [];
    updatedPoolData.portfolioBuilders && updatedPoolData.portfolioBuilders.map((option) => combinedData.push(option));
    updatedPoolData.portfolioSolutions && updatedPoolData.portfolioSolutions.map((option) => combinedData.push(option));
    updatedPoolData.valueDriven && updatedPoolData.valueDriven.map((option) => combinedData.push(option));
    
    let updatedData = this.props.modifiedAllocationData;
    for (const pool in updatedData.portfolioBuildersForm) {
      if (Object.prototype.hasOwnProperty.call(updatedData.portfolioBuildersForm, pool)) {
        if(updatedData.portfolioBuildersForm[pool]["Percentage"] > 0 )
        arr.push({ [pool]: updatedData.portfolioBuildersForm[pool] });
      }
    }
    for (const pool in updatedData.portfolioSolutionsForm) {
        if (Object.prototype.hasOwnProperty.call(updatedData.portfolioSolutionsForm, pool)) {
          if(updatedData.portfolioSolutionsForm[pool]["Percentage"] > 0 )
          arr.push({ [pool]: updatedData.portfolioSolutionsForm[pool] });
        }
    }
    for (const pool in updatedData.valueDrivenForm) {
        if (Object.prototype.hasOwnProperty.call(updatedData.valueDrivenForm, pool)) {
          if(updatedData.valueDrivenForm[pool]["Percentage"] > 0 )
          arr.push({ [pool]: updatedData.valueDrivenForm[pool] });
        }
    }
    for(const pool in arr) {
      const aB = combinedData.filter((data) => {

        if (replacer(data.investmentOption) === Object.keys(arr[pool])[0]) {
          return true;
        }
      });
      if(aB[0]){
      if(aB[0].multiFund == "1"){
        multiFundPools.push({
      "mName": aB[0].investmentOption ,
      "poolNumber": aB[0].poolNumber,
      "mRkInstrumentId": aB[0].poolId,
      "currentPoolPrice": aB[0].currentNav,
      "futureAllocPercentage": arr[pool][Object.keys(arr[pool])[0]]["Percentage"]
      })
    }else if(aB[0].multiFund == "0"){
      singleFundPools.push({
        "mName": aB[0].investmentOption ,
        "poolNumber": aB[0].poolNumber,
        "mRkInstrumentId": aB[0].poolId,
        "currentPoolPrice": aB[0].currentNav,
        "futureAllocPercentage": arr[pool][Object.keys(arr[pool])[0]]["Percentage"]
        })
    }
  }
    }
  return {multiFundPools, singleFundPools};
  }

  onExitClick = () => {
    try {
      popUpState = true;
      this.setState({
        show: true
      });
    } catch (error) {
      recordError(error);
    }
  }

  closeModal = () => {
      popUpState = false;
      this.setState({
        show: false
      });
    };

  removePopupContent = this.props.alertData && this.props.alertData.exit && this.props.alertData.exit.length ? 
  {
    heading: this.props.alertData.exit[0].field_header,
    line1: this.props.alertData.exit[0].field_description,
    line2: '',
    continue: this.props.alertData.exit[0].field_alert_button1_text,
    cancel: this.props.alertData.exit[0].field_alert_button2_text,
    type: "Info"
  } : {
      heading: "Exit Make A Contribution",
      line1: "Are you sure you want to Cancel this Contribution ?",
      line2: "Do you want to continue ?",
      continue: "continue",
      cancel: "No, take me back",
      type: "removeInfo"
    };

    onRemoveClick = () => {
      document.body.style.overflow = "";
      this.analyticsTracking('Exit');
      history.push("/");
    }

    analyticsTracking = (value) => {
      initiateTracking(value.toLowerCase(),'Make a Contribution', 'Step 3 Review Contribution and Submit' ,value);
    }

    analyticsEditTracking = (value) => {
      initiateTracking('edit','Make a Contribution', value ,'Edit - Body');
    }

    productInfo = (data) => {
      return {     
          "id": data[2],
          "name": data[0],
          "price": data[1] ? replaceNonDigit(data[1]).replace(/,/g, '') : '0',
          "quantity": data[3],
          "category": data[4]
         }
    }

    eCommerceAnalytics = () => {
      try {
          const data = this.props.contributionTypes;
          let products = [];
          let totalRevenue = 0;
          const assetAtMfs = data.assetHeldatVG.mfSelected ? data.assetHeldatVG.mutualFund : null;
          const assetAtSgs = data.assetHeldatVG.sgSelected ? data.assetHeldatVG.securityGift : null;
          const assetOutMfs = data.assetOutsideVG.mfSelected ? data.assetOutsideVG.mutualFund : null;
          const assetOutSgs = data.assetOutsideVG.sgSelected ? data.assetOutsideVG.securityGift : null;
          const check = data.checkOrEBT.checkSelected ? data.checkOrEBT.checkEBTList : null;
          const wire = data.wire.wireSelected ? data.wire.wireList : null;
          const stock = data.stockCertificate.stockSelected ? data.stockCertificate.stockCertificateList : null;
          if(assetAtMfs){
            assetAtMfs.map((mutualFund) => {
              mutualFund.fundInformation.map((fund) => {
                products.push(this.productInfo(["Asset held at Vanguard - mutual fund",0,1,1,'Contribution in Shares']))
              })
            })
          }
          if(assetAtSgs){
            assetAtSgs.map((mutualFund) => {
              mutualFund.fundInformation.map((fund) => {
                products.push(this.productInfo(["Asset held at Vanguard - security gift",0,2,1,'Contribution in Shares']))
              })
            })
          }
          if(assetOutMfs){
            assetOutMfs.map((mutualFund) => {
              mutualFund.fundInformation.map((fund) => {
                products.push(this.productInfo(["Asset held outside Vanguard - mutual fund",0,3,1,'Contribution in Shares']))
              })
            })
          }
          if(assetOutSgs){
            assetOutSgs.map((mutualFund) => {
              mutualFund.fundInformation.map((fund) => {
                products.push(this.productInfo(["Asset held outside Vanguard - security gift",0,4,1,'Contribution in Shares']))
              })
            })
          }
          if(check){
            check.map((singleCheck) => {
                totalRevenue += parseFloat(replaceNonDigit(singleCheck.amount).replace(/,/g, '')) * 100 ; 
                products.push(this.productInfo(["Check or electronic bank transfer",singleCheck.amount, 5,1,'Contribution in Dollars']))
              })
          }
          if(wire){
            wire.map((singleWire) => {
                totalRevenue += parseFloat(replaceNonDigit(singleWire.amount).replace(/,/g, '')) * 100;
                products.push(this.productInfo(["Wire",singleWire.amount,6,1,'Contribution in Dollars']))
            })
          }
          if(stock){
            stock.map((stockCert) => {
              stockCert.fundInformation.map((fund) => {
                products.push(this.productInfo(["Stock certificate",0,7,1,'Contribution in Shares']))
              })
            })
          }
          const eCommerceData = {
            purchase : {
              actionField: { id: this.props.isApiSuccess.transactionId,
                            revenue: totalRevenue ? totalRevenue /100 : 0
                          },
              products
            }
          }
          initiateTracking('eCommerce',eCommerceData);
      } 
      catch(error) {
        
      }
    }

    
    render() {
      if(this.props.isApiSuccess === "Error"){
        isSubmitClicked = false;
         this.props.updateContributionError();
      }
      if(this.props.isApiSuccess && this.props.isApiSuccess.transactionId){
        this.eCommerceAnalytics();
        window.scrollTo(0, 0);
        history.push({ pathname : "/contributions/make-a-contribution/funding-instructions",
                        state: {transactionId : this.props.isApiSuccess.transactionId}});
      }
      if(isSubmitClicked){
        window.scrollTo(0, 0);
        return <Preloader />
      }
        return (
            <div>
               {popUpState === true ? (
            <Popup
              data-test='popup'
              height="313px"
              width="481px"
              mwidth="88%"
              mheight="53%"
              content={this.removePopupContent}
              closeModal={this.closeModal}
              handleRemove={() => this.onRemoveClick()}
            />
          ) : null }
               <SectionHeading marginBottom="5px">Review your contribution</SectionHeading>
               <ContribType>Please review your contribution details below and edit, if needed, before submitting.</ContribType>
               <ComponentDivide marginTop="50px" marginBottom="50px" mB="40px" mT="40px"/>
               <EditButtonWrap>
                  <SectionHeading marginBottom="20px" mB='20px'>Contribution Type</SectionHeading>
                  <EditWrap><EditLinkToPill 
                   data-test='edit-pill'
                   prefixId='contrib-review'
                   analyticsTracking={ () => this.analyticsEditTracking('Step 3 Review contribution and submit - Contribution Type')}
                   linkPathname="/contributions/make-a-contribution" advisorType="step1Edit" active={true}/></EditWrap>
               </EditButtonWrap>
               <ContributionType />

                <EditButtonWrap>
                <SectionHeading marginBottom="20px" mB='0'>Investment Allocation </SectionHeading>
                <EditWrap >
                  <EditLinkToPill
                  id="anrEdit"
                  data-test='edit-pill1'
                  prefixId="contrib-review-edit"
                  prefixId="mac-edit"
                  analyticsTracking={ () => this.analyticsEditTracking('Step 3 Review contribution and submit - Investment Allocation')}
                  linkPathname="/contributions/make-a-contribution/investment-allocation" advisorType="step2Edit" active={true}/>
                </EditWrap>
               </EditButtonWrap>
               <BusinessDate>as of {this.props.lastBusinessDate}</BusinessDate>
               <Row>
                  <Col xs={0} lg={24}>
                    <Allocation />
                  </Col>
                  <Col xs={24} lg={0}>
                      <InvestmentAllocationCard />
                  </Col>
                </Row>
               <ComponentDivide marginTop="50px" marginBottom="50px" mB="40px" mT="40px"/>
               <SectionHeading marginBottom="10px" fSize="24px">Disclaimer</SectionHeading>
                <Disclaimer> { this.props.drupalData ? <div dangerouslySetInnerHTML={{__html: (this.props.drupalData && this.props.drupalData.step3Disclaimer && this.props.drupalData.step3Disclaimer.field_disclaimer_content ? this.props.drupalData.step3Disclaimer.field_disclaimer_content : '' ) }}></div> : ""} </Disclaimer>
                <ComponentDivide marginTop="50px" marginBottom='50px' mB="24px" mT="40px"/>
      <DisplayFlexSpaceMobile marginBottom='0'>
              <DisplayFlex>
                <GeneralButton 
                  id="btnBack"
                  text = "Back"
                  width = "150px"
                  mobWidth = "100%"
                  styling= "mr2 mb2"
                  type = "functional"
                  inverted = {true}
                  onClick={this.handleBackClick}
                />
                <GeneralButton 
                  id="btnExit"
                  text = "Exit"
                  width = "150px"
                  mobWidth = "100%"
                  styling= "left mb2"
                  type = "functional"
                  inverted = {true}
                  onClick={this.onExitClick}
                />
              </DisplayFlex>

      <GeneralButton 
              data-test='general-btn-submit'
              id="btnSubmit"
              text = {this.state.isSubmitClicked?<Spinner/>:"Submit"}
              width = "150px"
              mobWidth = "100%"
              styling= "right mb3"
              disabled={isGeminiUser()}
              onClick={() => this.handleNext()}
            />
            </DisplayFlexSpaceMobile>
            </div>
        );
    }
}

ReviewContributionAndSubmit.propTypes = {
  totalValue: PropTypes.number,
  defaultAllocationData: PropTypes.object,
  modifiedAllocationData: PropTypes.object,
  lastBusinessDate: PropTypes.string,
  contributionTypes: PropTypes.object,
  alertData: PropTypes.object,
  dropdownVal : PropTypes.object,
  isApiSuccess: PropTypes.object,
  drupalData: PropTypes.object,
  createContribution: PropTypes.func,
  updateContributionError: PropTypes.func,
}

const mapStateToProps = state => ({
    ...reviewContributionAndSubmitState(state.toJS())
  });

export const mapDispatchToProps = dispatch => ({
    createContribution: (data) => dispatch(createContribution(data)),
    updateContributionError: () => dispatch(updateContributionError())
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReviewContributionAndSubmit));

